import { CoreApi, ProductType } from '@inter-ikea-storageone/range';

export const selectedEntityIsNotClothRail = (coreApi: CoreApi): boolean => {
  const selectedProduct = coreApi.entities.findSelectedEntity();
  if (!selectedProduct) {
    return false;
  }
  return !coreApi.entities.isProductType(selectedProduct, ProductType.AURDAL_EXT_CLOTH_RAIL);
};
